import { createSelector } from 'selectors'

import { constant } from './constant'

const { selector } = constant

const getTargets = () => createSelector<NodeListOf<HTMLElement>>({ selector: `.${selector.target}` }, true)

const getRows = (scope?: HTMLElement) =>
	createSelector<NodeListOf<HTMLElement>>({ scope, selector: `.${selector.rows}` }, true)

export const selectors = {
	getTargets,
	getRows,
}
